import { PropsWithChildren } from "react";
import { Box } from "@mui/material";

export const PaperContainer = (props: PropsWithChildren) => {
    return <Box sx={{ padding: "1em" }}>{props.children}</Box>;
};
